import {
  BACK_URL,
} from '@/utils/const';

import AxiosObj from 'axios';

import helpers from './api/helpers';
import projects from './api/projects';
import registration from './api/registration';
import auth from './api/auth';
import tasks from './api/tasks';
import jobs from './api/jobs';
import reports from './api/reports';
import settings from './api/settings';
import user from './api/user';
import filters from './api/filters';
import overviews from './api/overviews';
import dashboard from './api/dashboard';
import documentation from './api/documentation';
import errorCategory from './api/errorCategory';
import textCategory from './api/textCategory';

import axiosErrorMiddleware from '@/models/interceptors';

const axios = AxiosObj.create();

axios.defaults.baseURL = BACK_URL;

axios.interceptors.request.use((request) => {
  const token = localStorage.getItem('user-token');
  if (token !== null) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

axios.interceptors.response.use((resp) => {
  return resp;
}, axiosErrorMiddleware);

const Api = {

  ...helpers(axios),

  /**
   * Project detail page
   */
  projects: {

    ...projects(axios),

  },

  /**
   * Registration page
   */
  registration: {

    ...registration(axios),

  },

  /**
   * Auth page
   */
  auth: {

    ...auth(axios),

  },

  /**
   * Task page
   */
  tasks: {

    ...tasks(axios),

  },

  /**
   * Jobs page
   */
  jobs: {

    ...jobs(axios),

  },

  /**
   * Reports page
   */
  reports: {

    ...reports(axios),

  },

  /**
   * Settings page
   */
  settings: {

    ...settings(axios),

  },

  /**
   * For user
   */
  user: {

    ...user(axios),

  },

  /**
   * Filters
   */
  filters: {

    ...filters(axios),

  },

  /**
   * Overviews
   */
  overviews: {

    ...overviews(axios),

  },

  /**
   * Dashboards
   */
  dashboard: {

    ...dashboard(axios),

  },

  /**
   * Documentation
   */
  documentation: {

    ...documentation(axios),

  },

  /**
   * Error category
   */
  errorCategory: {
    ...errorCategory(axios),
  },

  textCategory: {

    ...textCategory(axios),

  },

};

export default Api;
